<template>
  <div class="table-overflow" v-if="faunaLicenses.length > 0">
    <table class="table-full">
      <thead>
      <tr>
        <td>{{ $t('Вид животного') }}</td>
        <td class="text-center">{{ $t('Кол-во гол. в заявке') }}</td>
        <td class="text-center">{{ $t('Квота') }}</td>
        <td class="text-center">{{ $t('Кол-во выданных ранее') }}</td>
        <td class="text-center">{{ $t('Кол-во разрешений') }}</td>
        <td class="text-center">{{ $t('Кол-во отстр. карт') }}</td>
        <td class="text-center" v-if="foreignCitizenTypeFlag">{{ $t('Кол-во троф. листов') }}</td>
        <td class="text-center" v-if="editable">{{ $t('Действия') }}</td>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(item, index) in faunaLicenses" :key="index">
        <td>{{ item.faunaName }}</td>
        <td class="text-center">{{ item.headCount }}</td>
        <td class="text-center">{{ item.limitHeadQuantityQuota ? item.limitHeadQuantityQuota : $t('нет')  }}</td>
        <td class="text-center"></td>
        <td class="text-center">{{ item.permitCount }}</td>
        <td class="text-center">{{ item.shootingCardCount }}</td>
        <td class="text-center" v-if="foreignCitizenTypeFlag">{{ item.faunaTrophyLeaf === true ? item.headCount : $t('нет') }}</td>
        <td :rowspan="faunaLicenses.length" class="text-center" v-if="editable && index === 0"><IssueBsoForm :licenseApplicationId="licenseApplication"/></td>
      </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import IssueBsoForm from '@/components/license/IssueBsoForm'

export default {
  components: {
    IssueBsoForm
  },
  props: {
    licenseApplication: Number,
    faunaLicenses: Array,
    editable: Boolean,
    foreignCitizenTypeFlag: Boolean
  },
  data: () => ({})
}
</script>
